import getValueOffPercent from 'lib/offer/getValueOffPercent'

interface CharterBundleSearchTilePricingOptions {
  charterSearchPrices?: App.OfferListMetaData['pricing']
}

export interface CharterBundleSearchTilePricing {
  price: number
  memberPrice?: number
  value?: number
  discountPercent?: number
  memberDiscountPercent?: number
}

export function getCharterBundleSearchTilePricing({
  charterSearchPrices,
}: CharterBundleSearchTilePricingOptions): CharterBundleSearchTilePricing | undefined {
  return charterSearchPrices?.lowestPrice ? {
    price: charterSearchPrices.lowestPrice,
    memberPrice: charterSearchPrices.lowestMemberPrice,
    value: charterSearchPrices.lowestPriceValue,
    discountPercent: charterSearchPrices.lowestPriceValue
      ? getValueOffPercent(charterSearchPrices.lowestPriceValue, charterSearchPrices.lowestPrice)
      : undefined,
    memberDiscountPercent: charterSearchPrices.lowestPriceValue && charterSearchPrices.lowestMemberPrice
      ? getValueOffPercent(charterSearchPrices.lowestPriceValue, charterSearchPrices.lowestMemberPrice)
      : undefined,
  } : undefined
}
